<template>
	<div class="juml-view">
		<div class="juml-toolbar my-3">
			<div class="actions d-flex flex-wrap gap-2">
					<button
						v-if="userHasAllNeededJuniperPermissions(['create_users'])"
						@click="openCreateOrUpdateUserModal()"
						class="j-action-btn juml-action-toolbar-btn--primary"
					>
						<font-awesome-icon :icon="['fas', 'user-plus']" class="me-1" /> Create
					</button>
					<button v-if="userHasAllNeededJuniperPermissions(['revoke_user_token'])" @click="logoutUsers()" class="j-action-btn">
						<font-awesome-icon :icon="['fas', 'door-open']" class="me-1" /> Logout All
					</button>
			</div>
			<div class="search">
				<div class="form-group">
					<input type="text" @change="getUsers" v-model="search" class="form-control" placeholder="Search users..." />
				</div>
			</div>
		</div>
		<div class="juml-panel">
			<div class="row" v-if="!loading">
				<div id="tw-users-table-wrapper" class="col-md-12">
					<table v-if="users.length > 0" class="table table-hover align-middle mb-0 juml-table">
						<thead>
							<tr>
								<th width="50" class="text-center">#</th>
								<th class="text-start">Name</th>
								<th class="text-start">Email</th>
								<th>Roles</th>
								<th class="text-nowrap">Active Token</th>
								<th class="text-nowrap">Last Activity</th>
								<th width="120">Status</th>
								<th width="250">Actions</th>
							</tr>
						</thead>
						<tbody>
							<tr class="" v-for="user in users" :key="user.id + '-key'">
								<td class="text-center">{{ user.id }}</td>
								<td class="text-start text-nowrap">
									<a v-if="userHasAllNeededJuniperPermissions(['update_users'])" role="button" @click="updateUserAction = true, openCreateOrUpdateUserModal(user)">{{ user.name }}</a>
									<span v-else>{{ user.name }}</span>
								</td>
								<td>{{ user.email }}</td>
								<td>{{ user.roles.length ? user.roles.map(role => role.name).join(', ') : '' }}</td>
								<td>
									<font-awesome-icon v-if="user.hasActiveToken" class="text-success" :icon="['fas', 'check-circle']" />
									<font-awesome-icon v-else class="text-danger" :icon="['fas', 'times-circle']" />
								</td>
								<td class="text-nowrap">
									{{ user.lastLogin || 'more then 8 hours' }}
								</td>
								<td>
									<span v-if="user.active" class="badge bg-success">Active</span>
									<span v-else class="badge bg-danger">Inactive</span>
								</td>
								<td class="text-nowrap">
										<button
											class="juml-action-btn me-1"
                                            data-bs-html="true" data-bs-toggle="tooltip" data-bs-placement="top"
                                            v-if="userHasAllNeededJuniperPermissions(['mail_user_reset_password_link'])"
                                            @click="sendPasswordResetLink(user)"
                                            role="button"
                                            title="Mail to user resert password link"
                                        >
                                            <font-awesome-icon :icon="['far', 'paper-plane']" />
                                        </button>
										<button
											class="juml-action-btn me-1"
                                            data-bs-html="true" data-bs-toggle="tooltip" data-bs-placement="top"
                                            v-if="userHasAllNeededJuniperPermissions(['update_users'])"
                                            @click="updateUserAction = true, openCreateOrUpdateUserModal(user)"
                                            role="button"
                                            title="Edit"
                                        >
                                            <font-awesome-icon :icon="['fas', 'edit']" class="" />
                                        </button>
										<button
											class="juml-action-btn me-1"
                                            data-bs-html="true" data-bs-toggle="tooltip" data-bs-placement="top"
                                            v-if="userHasAllNeededJuniperPermissions(['revoke_user_token'])"
                                            @click="logoutUsers(user.id)"
                                            role="button"
                                            title="Logout user"
                                        >
                                            <font-awesome-icon :icon="['fas', 'door-open']" class="" />
                                        </button>
										<button
											class="juml-action-btn me-1"
											:class="user.active ? 'juml-action-btn--danger' : 'juml-action-btn--success'"
                                            data-bs-html="true" data-bs-toggle="tooltip" data-bs-placement="top"
                                            v-if="userHasAllNeededJuniperPermissions(['activate_users', 'deactivate_users'])"
                                            @click="toggleUserActiveStatus(user)"
                                            role="button"
                                            :title="user.active ? 'Deactivate user account' : 'Activate user account'"
                                        >
                                            <font-awesome-icon v-if="user.active" :icon="['fas', 'user-times']" class="" />
                                            <font-awesome-icon v-else :icon="['fas', 'user-check']" class="" />
                                        </button>
										<button
											class="juml-action-btn juml-action-btn--danger"
                                            data-bs-html="true" data-bs-toggle="tooltip" data-bs-placement="top"
                                            v-if="userHasAllNeededJuniperPermissions(['delete_users'])"
                                            @click="deleteUser(user)"
                                            role="button"
                                            title="Delete user"
                                        >
                                            <font-awesome-icon :icon="['fas', 'trash']" class="" />
                                        </button>
								</td>
							</tr>
						</tbody>
					</table>
					<div v-else class="juml-empty">
						There are no users available.
					</div>
				</div>
			</div>
			<div v-else class="d-flex justify-content-center p-4">
				<div class="spinner-border" role="status">
					<span class="visually-hidden">Loading...</span>
				</div>
			</div>
		</div>
		<!-- Pagination -->
		<div class="mt-2 p-1">
			<Pagination :totalItems="totalUsers" :currentPage="page" :perPage="perPage" @pageChanged="setPage" :goButton="false" styled="simple" borderActiveColor="" borderTextActiveColor="text-white" :float-right="true" />
		</div>
		<CreateOrUpdateUserModal ref="CreateOrUpdateUserModal" :update="updateUserAction" :userForChildComponent="user" @userSaved="handleUserSaved" @createOrUpdateUserModalClosed="handleCreateOrUpdateUserModalClosed" />
	</div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import juniperApi from '@/api/juniperApi';
import Pagination from "@/components/juniper/pagination/Pagination";
import CreateOrUpdateUserModal from '@/components/juniper/modals/CreateOrUpdateUserModal.vue';
import { Tooltip } from "bootstrap";
import juniperUserMixin from "@/mixins/juniperUserMixin";
export default {
	name: 'UsersList',
	data() {
		return {
			loading: false,
			users: [],
			page: 1,
			totalUsers: 0,
			perPage: 10,
			search: '',
			pagination: null,
            user: {
				email: '',
				username: '',
				password: '',
				password_confirmation: '',
			},
            updateUserAction: false,
		}
	},
	components: {
		Pagination,
        CreateOrUpdateUserModal
	},
	computed: {
		...mapState(['authUser']),
		...mapGetters(['isAuth']),
	},
    updated() {
		let tooltopElements = document.querySelectorAll('[data-bs-toggle="tooltip"]');

		tooltopElements.forEach(element => {

			let tooltip = Tooltip.getInstance(element);

			if (tooltip) {
				tooltip.dispose();
			}

			if (!Tooltip.getInstance(element)) {
				new Tooltip(element)
			}
		});
	},
	created() {
		this.getUsers()
	},
	watch: {
        perPage: function () {
            this.getUsers();
        },
        page: function () {
            this.getUsers();
        },
        // orderBy: function () {
        //     this.getUsers();
        // },
        // order: function () {
        //     this.getUsers();
        // },
        // search: function () {
        //     this.getUsers();
        // },
    },
	methods: {
		// Get users
		getUsers() {
			this.loading = true
			juniperApi
				.get(`/users?per_page=${this.perPage}&search=${this.search}&page=${this.page}`)
				.then(({ data }) => {
					this.users = data.users;
					this.page = data.page;
					this.totalUsers = data.count;
					this.loading = false;
				})
				.catch(error => {
					this.loading = false
					console.log(error)
				})
		},

		async sendPasswordResetLink(user) {

			this.$swal({
                title: "Are you sure?",
                showCancelButton: true,
                icon: "warning",
                text: `Are you sure you want to send reset password link to this user?`,
                confirmButtonText: "Yes, send it!",
                showLoaderOnConfirm: true,
				toast: false,
				position: 'center',
				showConfirmButton: true,
				timer: undefined,
				timerProgressBar: false,
				confirmButtonColor: "#0FCB4F",
				cancelButtonColor: "#EC2641",
                preConfirm: async () => {
                    try {
                        let res = await juniperApi.post('forgot-password', { site_url: this.client.staging ? this.client.staging_url : this.client.url, email: user.email });

                        return res;
                    } catch (error) {
                        this.$swal.showValidationMessage(`Request failed: ${error}`);
                    }
                },
                allowOutsideClick: () => !this.$swal.isLoading(),
            }).then(async (result) => {
                if (result.isConfirmed) {
					console.log(result)
					if (result.value && result.value.data && result.value.data.status && result.value.data.status == 'We have emailed your password reset link!') {
						
						this.$swal("Sent!", `Email with password reset link sent to user!`, "success").then(() => {
	
						});
						this.loading = true;
						this.getUsers();
					} else if(result.value && result.value.data && result.value.data.type && result.value.data.type == 'error') {
						console.log(result.value.data.errors)
						this.$swal("Request failed!", result.value.data.errors && result.value.data.errors.status ? result.value.data.errors.status : "There was a problem, password reset link wasn't send.", "error");
					} else {
						this.$swal("Request failed!", "There was a problem, password reset link wasn't send.", "error");
					}
                }
            });
		},		

		openCreateOrUpdateUserModal(user = this.user) {
			this.user = user;
            this.$refs.CreateOrUpdateUserModal.showModal(true);
        },

		handleUserSaved() {
			this.loading = true;
			this.getUsers();
		},

		toggleUserActiveStatus(user) {
			this.$swal({
                title: "Are you sure?",
                showCancelButton: true,
                icon: "warning",
                text: `Are you sure you want to make this user's account ${user.active ? 'inactive' : 'active'}?`,
                confirmButtonText: `Yes, make it ${user.active ? 'inactive' : 'active'}!`,
                showLoaderOnConfirm: true,
				toast: false,
				position: 'center',
				showConfirmButton: true,
				timer: undefined,
				timerProgressBar: false,
				confirmButtonColor: "#0FCB4F",
				cancelButtonColor: "#EC2641",
                preConfirm: async () => {
                    try {
                        let res = await juniperApi.post(`/users/${user.id}/${user.active ? 'deactivate' : 'activate'}`, {});

                        return res;
                    } catch (error) {
                        this.$swal.showValidationMessage(`Request failed: ${error}`);
                    }
                },
                allowOutsideClick: () => !this.$swal.isLoading(),
            }).then(async (result) => {
                if (result.isConfirmed) {
					if (result.value && result.value.data == 'success') {
						
						this.$swal(`${user.active ? 'Deactivated' : 'Activated'}!`, `User ${user.active ? 'deactivated' : 'activated'} successfully!`, "success").then(() => {
	
						});
						this.loading = true;
						this.getUsers();
					} else {
						this.$swal("Request failed!", `There was a problem, user's account wasn't ${user.active ? 'deactivated' : 'activated'}.`, "error");
					}
                }
            });
		},
		deleteUser(user) {
			this.$swal({
                title: "Are you sure?",
                showCancelButton: true,
                icon: "warning",
                html: `Are you sure you want to delete user <b>${user.name}</b>?`,
                confirmButtonText: "Yes, delete the user!",
                showLoaderOnConfirm: true,
				toast: false,
				position: 'center',
				showConfirmButton: true,
				timer: undefined,
				timerProgressBar: false,
				confirmButtonColor: "#0FCB4F",
				cancelButtonColor: "#EC2641",
                preConfirm: async () => {
                    try {
                        let res = await juniperApi.delete(`/users/${user.id}`, {});

                        return res;
                    } catch (error) {
                        this.$swal.showValidationMessage(`Request failed: ${error}`);
                    }
                },
                allowOutsideClick: () => !this.$swal.isLoading(),
            }).then(async (result) => {
                if (result.isConfirmed) {
					if (result.value && result.value.data == 'success') {
						
						this.$swal("Deleted!", `User deleted successfully!`, "success");
						this.loading = true;
						this.getUsers();
					} else {
						this.$swal("Request failed!", "There was a problem, user wasn't deleted.", "error");
					}
                }
            });
		},

		logoutUsers(id = null) {
			let ids = [];
            let users = {};
			if (id) {
				ids.push(id);
                users = {users: ids};
			}

			this.$swal({
                title: "Are you sure?",
                showCancelButton: true,
                icon: "warning",
                text: `Are you sure you want to logout user/s?`,
                confirmButtonText: "Yes, I am!",
                showLoaderOnConfirm: true,
				toast: false,
				position: 'center',
				showConfirmButton: true,
				timer: undefined,
				timerProgressBar: false,
				confirmButtonColor: "#0FCB4F",
				cancelButtonColor: "#EC2641",
                preConfirm: async () => {
                    try {
                        let res = await juniperApi.post(`users/sanctum/revoke-token`, users);

                        return res;
                    } catch (error) {
                        this.$swal.showValidationMessage(`Request failed: ${error}`);
                    }
                },
                allowOutsideClick: () => !this.$swal.isLoading(),
            }).then(async (result) => {
                if (result.isConfirmed) {
					if (result.value && result.value.data == 'success') {
						
						this.$swal("Logged out!", `User/s loggout successfully!`, "success");
						this.loading = true;
						this.getUsers();
					} else {
						this.$swal("Request failed!", "There was a problem, user/s wasn't logged out.", "error");
					}
                }
            });
		},
		
		handleCreateOrUpdateUserModalClosed() {
			this.user = {
                email: '',
				username: '',
				password: '',
				password_confirmation: ''
			};
			this.updateUserAction = false;
		},

		setPage(n) {
            this.page = n;
        },
	},
    mixins: [juniperUserMixin]
}
</script>
<style scoped>
#tw-users-table-wrapper {
	overflow-x: auto;
}

.juml-toolbar {
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 10px;
	flex-wrap: wrap;
}

.juml-toolbar .search {
	min-width: 260px;
}

.juml-panel {
	background: #ffffff;
	border: 1px solid #e2e8f0;
	border-radius: 14px;
	padding: 0;
	min-height: calc(100vh * .72);
	overflow: hidden;
}

.juml-table thead th {
	font-size: 12px;
	color: #64748b;
	font-weight: 700;
	border-bottom-color: #e2e8f0;
	background: #f8fafc;
	padding: 12px 10px;
}

.juml-table tbody td {
	padding: 12px 10px;
	border-bottom-color: #eef2f7;
}

.juml-table tbody tr:hover {
	background: #f8fbff;
}

.juml-table tbody tr:last-child td {
	border-bottom: 0;
}

.juml-table tbody a[role='button'] {
	color: #1d4ed8;
	font-weight: 600;
	text-decoration: none;
}

.juml-table tbody a[role='button']:hover {
	text-decoration: underline;
}

.juml-action-btn {
	width: 30px;
	height: 30px;
	border-radius: 8px;
	border: 1px solid #d6deea;
	background: #f8fafc;
	color: #334155;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 0;
	transition: all 0.2s ease;
}

.juml-action-btn:hover {
	background: #eef2f7;
	border-color: #b7c4d6;
	color: #1f2937;
}

.juml-action-btn--danger {
	color: #dc2626;
	border-color: #f3c1c1;
	background: #fef2f2;
}

.juml-action-btn--danger:hover {
	background: #fee2e2;
	border-color: #ef9a9a;
	color: #b91c1c;
}

.juml-action-btn--success {
	color: #15803d;
	border-color: #b7e3c5;
	background: #ecfdf3;
}

.juml-action-btn--success:hover {
	background: #dcfce7;
	border-color: #86d8a4;
	color: #166534;
}

.juml-action-toolbar-btn--primary {
	background: #2563eb;
	border-color: #2563eb;
	color: #fff;
}

.juml-action-toolbar-btn--primary:hover {
	background: #1d4ed8;
	border-color: #1d4ed8;
	color: #fff;
}

.juml-empty {
	text-align: center;
	padding: 28px 10px;
	font-size: 16px;
	color: #64748b;
}
</style>
